<script>
  /**
   * 自由入力と候補リストからの選択を同時に行えるテキスト入力欄
   */
  import Input from './Input.svelte'

  export let id
  export let name
  export let label
  export let list = []
  export let placeholder = undefined
  export let required = undefined
  export let isLoading = false

  export let value = undefined

  let attributes = {}
  $: listId = `${id}List`

  if (placeholder) attributes.placeholder = placeholder
</script>

<Input
  type="text"
  autocomplete="on"
  list={listId}
  {id}
  {name}
  {label}
  {isLoading}
  {...attributes}
  {required}
  bind:value
>
  <datalist id={listId}>
    {#if list}
      {#each list as option, index}
        <option data-testid={`${listId}Option-${index}`} value={option} />
      {/each}
    {/if}
  </datalist>
</Input>
